import {Trans} from '@lingui/macro'
import {useNavigate} from 'react-router-dom'
import {AccountCircle, LogoutSharp} from '@mui/icons-material'
import {Button, Box, useTheme} from '@mui/material'
import useLogout from '../../hooks/useLogout'
import {useContext} from "react";
import {ThemeContext} from "../../App";

export default function UserControls({state}) {
    const navigate = useNavigate()
    const logout = useLogout()
    const theme = useTheme()
    const { mode } = useContext(ThemeContext)

    return (
        <Box display="flex" gap={2} alignItems="center">
            <Button
                sx={{color: 'white'}}
                startIcon={<AccountCircle sx={{color: theme.palette.newColors.pink}}/>}
                onClick={() =>
                    navigate('/user', {state: {...state, isHistoryOpen: false}})
                }
            >
                <Trans>My profile</Trans>
            </Button>

            <Button
                startIcon={<LogoutSharp/>}
                onClick={logout}
                variant="contained"
                sx={{
                    background: theme.palette.newColors.pinkGradient,
                    color: 'error.contrastText',
                    '&:hover': {
                        bgcolor: 'error.main',
                    },
                }}
            >
                <Trans>Logout</Trans>
            </Button>
        </Box>
    )
}
